<div class="flex-container">
  <div class="flex-row">
    <div class="flex-col-6 flex-col-sm-12 categories">
      <app-profile-category
        *ngIf="stepStatus > 0 || hasCIAccount"
        [title]="'profile.title'"
        [activeTab]="activeTabName === 'showPersonal'"
        (click)="updateOpenedTab('showPersonal')"
      ></app-profile-category>
      <div class="mobile-detail-box" [ngClass]="{ active: activeTabName === 'showPersonal' }">
        <app-profile-personal-details (changeTab)="updateOpenedTab($event)"></app-profile-personal-details>
      </div>
      <app-profile-category
        *ngIf="hasI4KAccount"
        [title]="'profile.I4K.title'"
        [activeTab]="activeTabName === 'showI4K'"
        (click)="updateOpenedTab('showI4K')"
      ></app-profile-category>
      <div class="mobile-detail-box" [ngClass]="{ active: activeTabName === 'showI4K' }">
        <app-profile-i4k-names [customer]="customer"></app-profile-i4k-names>
      </div>
      <app-profile-category
        [title]="'personal.change_pass'"
        [activeTab]="activeTabName === 'showPass'"
        (click)="updateOpenedTab('showPass')"
      ></app-profile-category>
      <div class="mobile-detail-box" [ngClass]="{ active: activeTabName === 'showPass' }">
        <app-profile-change-password [customer]="customer"></app-profile-change-password>
      </div>
      <app-profile-category
        *ngIf="customer.provider === 'email' && customer.app_location === 'ch'"
        [title]="'profile.2fa'"
        [activeTab]="activeTabName === 'show2FA'"
        (click)="updateOpenedTab('show2FA')"
      ></app-profile-category>
      <div class="mobile-detail-box" [ngClass]="{ active: activeTabName === 'show2FA' }">
        <app-profile-2fa *ngIf="activeTabName === 'show2FA'"></app-profile-2fa>
      </div>
      <app-profile-category
        [title]="'profile.language.title'"
        [activeTab]="activeTabName === 'showLanguage'"
        (click)="updateOpenedTab('showLanguage')"
      ></app-profile-category>
      <div class="mobile-detail-box" [ngClass]="{ active: activeTabName === 'showLanguage' }">
        <app-profile-change-language [customer]="customer"></app-profile-change-language>
      </div>
      <a class="promotions-link" (click)="updateShowPromotions()">
        {{ 'modals.promotions.h2' | translate }}
      </a>
    </div>
  </div>
</div>
